export const builderActions = [
  'builder/doSetUpNewForm',
  'builder/setPreviewPage',
  'builder/doSetPreviewViewPort',
  'builder/doZoomForm',
  'builder/doShowCalculationModal',
  'builder/createResultField',
  'builder/doChangePage',
  'builder/showFieldError',
  'builder/doShowFormControlsModal',
  'builder/doShowLogicModal',
  'builder/setIsBuilderFormUpdated',
  'builder/setRedirectToCustomise',
  'builder/savingForm',
  'builder/doShowCtrlCalculationsModal',
  'builder/showCtrlRulesModal',
  'builder/removeCtrlRules',
  'builder/removeCtrlCalculations',
  'builder/doShowCtrlMultipleModal',
  'builder/fetchFormStart',
  'builder/fetchFormFailure',
  'builder/doShowClearPageModal',
  'builder/doShowUpgradePlanModal',
  'builder/doShowRemovePageModal',
  'builder/doTogglePageDeleteRuleText',
  'builder/doTogglePageDeleteCalculationText',
  'builder/doClearPage',
  'builder/doRemovePage',
  'builder/updateEditBarStatus',
  'builder/doShowIntroPageModal',
  'builder/doShowMobileSidebar',
  'builder/doHideMobileSidebar',
  'builder/showReportFormInBuilder',
  'builder/doShowTimerModal',
  'builder/doEnableTimer',
  'builder/saveTimerOptions',
  'builder/toggleTourGuide',
  'builder/doShowTour',
  'builder/updateAutoSave',
  'builder/doSaveUserOptions',
  'builder/fetchPDFSuccess',
  'builder/fetchIntroDetails',
  'builder/fetchPostDetails',
  'builder/doStoreUserForms',
  'builder/doStoreSourceForms',
  'builder/disablePaymentUserSpecify',
  'builder/doUpdateClosingPageProp',
  'builder/doUpdateIntroPageProp',
  'builder/doEnableClosingPage',
  'builder/doCreateClosingPage',
  'builder/doDeleteClosingPage',
  'builder/doResetClosingPage',
  'builder/saveClosingPageDetails',
  'builder/doShowClosingPageModal',
  'builder/doSwitchClosingPageIndex',
  'builder/doReorderClosingPages',
  'builder/doEnableIntroPage',
  'builder/doResetIntroPage',
  'builder/showBuilderError',
  'builder/setupSavedLocalForm',
  'builder/fetchFormSuccess',
  'builder/setRowId',
  // 'builder/resetCtrl',
  // 'builder/saveCtrl',
  'builder/clearFieldError',
  'builder/doChangePageName',
  // 'builder/replaceAllRules',
  // 'builder/showFieldIds',
  // 'builder/doSetFormRuleIdx',
  // 'builder/deleteRule',
  // 'builder/editRule',
  // 'builder/saveRule',
  // 'builder/removeRules',
  // 'builder/doSaveCalculation',
  // 'builder/doEditCalculation',
  // 'builder/doRemoveCalculation',
];

export const customiseActions = [
  'customise/fetchFormById/pending',
  'customise/fetchThemes/pending',
  'customise/fetchFonts/fulfilled',
  'customise/fetchThemes/fulfilled',
  'customise/fetchFormById/fulfilled',
  'customise/updateFormOptionsSuccess',
  'customise/displayMobileSidebar',
  'customise/showReportFormInCustomise',
];
